import { getFormSignatoryFromCcRecipient, getFormSignatoryFromDefaultCcRecipient, } from 'app/domains/esigning/utils';
export const getFormCcRecipients = (ccRecipients, defaultCcRecipients) => {
    if (ccRecipients.length > 0) {
        return ccRecipients.map(getFormSignatoryFromCcRecipient);
    }
    return defaultCcRecipients.map(getFormSignatoryFromDefaultCcRecipient);
};
